// extracted by mini-css-extract-plugin
export default {"Block":"NoTimeslotsAvailable-module__Block--JhBhb","Link":"NoTimeslotsAvailable-module__Link--LrrCO"};